import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule, JsonpModule } from '@angular/http';
import { AppComponent } from './App/app.component';
import { DataTableModule } from "angular2-datatable";
import { AppRoutingModule, routingComponents } from './app.routing';
import { HTTPService } from './Services/http.service';
import { filter } from './App/search.pipe';
import { filterExact } from './App/filterExact.pipe';
import { SortPipe } from './App/sortBy.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from './App/shared.service';
import { enableProdMode } from '@angular/core';
import { keys } from './App/key.pipe';



@NgModule({
  imports: [BrowserModule, FormsModule, HttpModule, AppRoutingModule, DataTableModule],
  declarations: [AppComponent, routingComponents, filter, filterExact, SortPipe, keys],
  providers: [HTTPService, MySharedService, filter, filterExact, SortPipe, DatePipe, keys],
  bootstrap: [AppComponent]
})

export class AppModule {
}

enableProdMode();
platformBrowserDynamic().bootstrapModule(AppModule);


/** WEBPACK FOOTER **
 ** ./TypeScripts/boot.ts
 **/